
export { RecipientForm } from "/home/runner/work/capsicum/capsicum/libs/features/digital-collectibles/web/src/ui/recipient-form/RecipientForm.tsx"